import React from 'react';
import PropTypes from 'prop-types';
import Image from "react-bootstrap/Image";
import defaultIcon from "../../assets/images/xrpl-symbol-black.svg";
import ammAccountIcon from "../../assets/images/icons/amm.svg";
import { REACT_APP_AVATAR_HOST, REACT_APP_AVATAR_CACHE_KEY } from '../../config';

const AccountIcon = (props) => {
    const {
        url,
        twitter,
        emailHash,
        isAmmAccount,
        rounded,
        roundedCircle,
        thumbnail,
        height,
        width,
        ttl,
    } = props;

    const getIconURL = () => {
        if (typeof url === 'string' && url.startsWith("https://")) {
            return url
        }
        else if (typeof twitter === 'string') {
            return `${REACT_APP_AVATAR_HOST}/x/${twitter}?ttl=${ttl}&fallback=https://xrpscan.com${defaultIcon}&k=${REACT_APP_AVATAR_CACHE_KEY}`;
        }
        else if (typeof emailHash === 'string' && emailHash.length > 0) {
           return `https://www.gravatar.com/avatar/${emailHash.toLowerCase()}.png?d=blank&s=400`
        }
        else if (isAmmAccount === true) {
            return ammAccountIcon;
        }
        else {
            return defaultIcon;
        }
    };
    
    const iconTag = <span className='mr-2'>
        <Image
            src={getIconURL()}
            rounded={rounded}
            roundedCircle={roundedCircle}
            thumbnail={thumbnail}
            height={height}
            width={width}
        />
    </span>
    return iconTag;
}

AccountIcon.defaultProps = {
    url: undefined,
    twitter: undefined,
    emailHash: undefined,
    isAmmAccount: false,
    rounded: false,
    roundedCircle: true,
    thumbnail: false,
    height: 18,
    width: 18,
    ttl: "28d",
}

AccountIcon.propTypes = {
    url: PropTypes.string,
    twitter: PropTypes.string,
    emailHash: PropTypes.string,
    isAmmAccount: PropTypes.bool,
    rounded: PropTypes.bool,
    roundedCircle: PropTypes.bool,
    thumbnail: PropTypes.bool,
    height: PropTypes.number,
    width: PropTypes.number,
    ttl: PropTypes.string,
}

export default AccountIcon;